import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { ParentUsers } from '../Models/ActiveClasses';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { loginUserList, managerlistbyuserid } from '../Models/BookingListProperties';
import { OfflineBookingAllList, OfflineRequestType } from '../Models/OfflineBookingProperties';
import { AgencyService } from '../Services/Agency.service';
import { BookingListService } from '../Services/bookingList.service';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { UIChart } from 'primeng/chart';
import { DxDataGridModule, DxCheckBoxModule } from 'devextreme-angular';
import { DxiColumnModule, DxoSelectionModule, DxoSearchPanelModule, DxoPagingModule, DxoGroupPanelModule, DxoGroupingModule, DxoExportModule } from 'devextreme-angular/ui/nested';
import { AsyncPipe } from '@angular/common';
@Component({
    selector: 'app-manager-proficiency-report',
    templateUrl: './manager-proficiency-report.component.html',
    styleUrls: ['./manager-proficiency-report.component.css'],
    imports: [NavMenuComponent, Bind, Toast, FormsModule, NgSelectModule, UIChart, DxDataGridModule, DxiColumnModule, DxoSelectionModule, DxoSearchPanelModule, DxoPagingModule, DxoGroupPanelModule, DxoGroupingModule, DxoExportModule, DxCheckBoxModule, AsyncPipe]
})
/** ManagerProficiencyReport component*/
export class ManagerProficiencyReportComponent {
  userId: number;
  /** ManagerProficiencyReport ctor */
  constructor(private bookingListService: BookingListService, private agencyservice: AgencyService, private messageService: MessageService) {

  }
  
  getOfflineRequestTypeList: OfflineRequestType[]=[];
  datasoruceBooking:OfflineBookingAllList[]=[];
  userlist: ParentUsers[] = [];
  agencyCodeList$: Observable<Agencies_BranchesProperties[]>;
  agencyCodefinalList$: Observable<Agencies_BranchesProperties[]>;
  managerProperties = new ManagerProficiencyReportProperties();
  agencyList: Agencies_BranchesProperties[] = [];
  newagencyList: Agencies_BranchesProperties[] = [];
  managerList: managerlistbyuserid[] = [];
  agencyhead: boolean = false;
  ngOnInit() {
    this.getlistofUsers((localStorage.getItem("AgencyId")));
    this.LoadAgencyList();
    this.getrequestType();

  }
  LoadAgencyList() {
    try {
      let loginAgency = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
          this.userId = Number(localStorage.getItem("UserId"));
        if (this.userId != 0) {
          this.bookingListService.GetAllAgencies(loginAgency, this.userId).subscribe((data) => {
            this.agencyList = data;
            this.agencyCodeList$ = of(data);
            this.bookingListService.getmanagerlistbyuserid(this.userId).subscribe((newdata) => {
              if (newdata.length > 0) {
                this.managerList = newdata;
                for (let i = 0; i < this.managerList.length; i++) {
                  if (this.managerList[i].agencyid == 'AG01') {
                    this.agencyhead = true;
                  }
                }
                if (this.agencyhead == true) {
                  this.agencyCodefinalList$ = this.agencyCodeList$;
                  this.agencyCodefinalList$.subscribe((data) => {
                    data.push({
                      code:  "All",
                      name: "",
                      country:  "",
                      email:  "",
                      status:  false,
                      labelName: "All",
                      backSystemCompanyName: "",
                      creationDate:""
                    });
                  })
                }
                else {
                  this.newagencyList = [];
                  for (let i = 0; i < this.managerList.length; i++) {
                    for (let j = 0; j < this.agencyList.length; j++) {
                      if (this.managerList[i].agencyid == this.agencyList[j].code) {
                        //let newagencyobj = new Agencies_BranchesProperties();
                        this.newagencyList.push(this.agencyList[j]);
                      }
                    }
                  }
                  this.agencyCodefinalList$ = of(this.newagencyList);

                }
              }
              else {
                this.newagencyList = [];
                let agencyIds = new Agencies_BranchesProperties();
                agencyIds.code = localStorage.getItem("AgencyId");
                agencyIds.labelName = localStorage.getItem("AgencyId");
                this.newagencyList.push(agencyIds)
                this.agencyCodefinalList$ = of(this.newagencyList);
                //console.log('nothing',newdata);
              }
            })

          });
        }
       
      }
    }
    catch (e) {
    }
  }
  getrequestType() {
    this.bookingListService.GetOfflineRequestTypeList().subscribe((data) => {
      //console.log(data);
      if (data.length > 0) {
        this.getOfflineRequestTypeList = data;
        //console.log(this.userlist);
      }
    })
  }
  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
      customizeCell: function (options) {
        const excelCell = options;
        // exce = { name: 'Arial', size: 12 };
        // excelCell.alignment = { horizontal: 'left' };
      }
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'B2BBackOfficeReport.xlsx');
        });
    });
    e.cancel = true;
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // months are 0-based
    return `${year}-${month}-${day}`;
  }
  onSubmit() {
    if ((this.managerProperties.startDate != undefined && this.managerProperties.endDate == undefined)) {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please select the Booking To date when Booking From date is selected.' });
      
      return;
    }
    if ((this.managerProperties.startDate == undefined && this.managerProperties.endDate != undefined)) {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please select the Booking From date when Booking To date is selected.' });

      return;
    }
    if ((this.managerProperties.startDate != undefined && this.managerProperties.endDate != undefined)) {
      const startdate = new Date(this.managerProperties.startDate);
      const enddate = new Date(this.managerProperties.endDate);
      if (startdate > enddate) {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please select the Booking From date is less than from Booking To date.' });

        return;
      }
      
    }
    if (this.managerProperties.bookingId == undefined || this.managerProperties.bookingId == null) {
      this.managerProperties.bookingId = 0;
    }
    if (this.managerProperties.modifyUser == undefined || this.managerProperties.modifyUser == null) {
      this.managerProperties.modifyUser = 0;
    }
    if (this.managerProperties.offlineBookingRequestId == undefined || this.managerProperties.offlineBookingRequestId == null) {
      this.managerProperties.offlineBookingRequestId = 0;
    }
    if (this.managerProperties.startDate != undefined || this.managerProperties.agencyBranchId != undefined || this.managerProperties.bookingId != 0 || this.managerProperties.endDate != undefined
      || this.managerProperties.modifyUser != 0 || this.managerProperties.offlineBookingRequestId != 0) {
      if (this.managerProperties.startDate != undefined) {
        const deptdate = new Date(this.managerProperties.startDate);
        this.managerProperties.startDate = this.formatDate(deptdate);
      }
      if (this.managerProperties.endDate != undefined) {
        const deptdate = new Date(this.managerProperties.endDate);
        this.managerProperties.endDate = this.formatDate(deptdate);
      }
      this.datasoruceBooking = [];
      this.bookingListService.ManagerGetProficiency(this.managerProperties).subscribe((data) => {
        //console.log(data);
        if (data.length > 0) {
          this.datasoruceBooking = data;
          this.loadCharts();
          //console.log(this.userlist);
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Empty', detail: 'Not Found Any Data' });
        }
      })
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please select criteria must be one field' });
      return;
    }
  
   
  }
  getlistofUsers(str) {
   
    if (str == null) {
      return;
    }
    /*  if (str.includes("B")) {*/
    this.userlist = [];

    this.agencyservice.GetUsersForManagers(str).subscribe((data) => {
      //console.log(data);
      if (data.length > 0) {
        this.userlist = data;
        //console.log(this.userlist);
      }
    })
    /*    }*/
  }
  dataStatus: any;
  dataRequestTypeOnline: any;
  dataRequestTypeOffline: any;
  options: any;
  loadCharts() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    let approve = this.datasoruceBooking.filter(ty => ty.status === "Approved").length;
    let reject = this.datasoruceBooking.filter(ty => ty.status === "Rejected").length;
    let ticketonline = this.datasoruceBooking.filter(ty => ty.requestType === 7).length;
    let voidonline = this.datasoruceBooking.filter(ty => ty.requestType === 8).length;
    let refundonline = this.datasoruceBooking.filter(ty => ty.requestType === 14).length;
    let importonline = this.datasoruceBooking.filter(ty => ty.requestType === 15).length;
    let request = this.datasoruceBooking.filter(ty => ty.status === "Requested").length;
    let ticketoffline = this.datasoruceBooking.filter(ty => ty.requestType === 3).length;
    let voidoffline  = this.datasoruceBooking.filter(ty => ty.requestType === 4).length;
    let refundoffline = this.datasoruceBooking.filter(ty => ty.requestType === 5).length;
    
    this.dataStatus = {
      labels: ['Requested', 'Approved', 'Rejected'],
      datasets: [
        {
          data: [request, approve, reject],
          backgroundColor: [documentStyle.getPropertyValue('--yellow-500'), documentStyle.getPropertyValue('--green-500'), documentStyle.getPropertyValue('--orange-500')],
          hoverBackgroundColor: [documentStyle.getPropertyValue('--yellow-400'), documentStyle.getPropertyValue('--green-400'), documentStyle.getPropertyValue('--orange-400')]
        }
      ]
    };
    this.dataRequestTypeOnline = {
      labels: ['Online Ticket Request', 'Online Void Request', 'Online Refund Request',  'Online Import PNR Request'],
      datasets: [
        {
          data: [ticketonline, voidonline, refundonline, importonline],
          backgroundColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--yellow-500'), documentStyle.getPropertyValue('--green-500'), documentStyle.getPropertyValue('--purple-500')],
          hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400'), documentStyle.getPropertyValue('--yellow-400'), documentStyle.getPropertyValue('--green-400'), documentStyle.getPropertyValue('--purple-400')]
        }
      ]
    };
    this.dataRequestTypeOffline = {
      labels: ['Offline Ticket Request', 'Offline Void Request', 'Offline Refund Request'],
      datasets: [
        {
          data: [ticketoffline, voidoffline, refundoffline],
          backgroundColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--yellow-500'), documentStyle.getPropertyValue('--green-500')],
          hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400'), documentStyle.getPropertyValue('--yellow-400'), documentStyle.getPropertyValue('--green-400')]
        }
      ]
    };

    this.options = {
      cutout: '60%',
      plugins: {
        legend: {
          labels: {
            color: textColor
          }
        }
      }
    };
  }
}
export class ManagerProficiencyReportProperties {
  startDate: string ;
  endDate: string ;
  agencyBranchId: string ;
  modifyUser: number=0;
  offlineBookingRequestId: number=0;
  bookingId: number=0;
}
